import { Button, Col, Form, Input, notification, Row, Select } from 'antd'
import AppContext from 'context/AppContext'
import React, { useContext, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import {
  useOkulKampusleriQuery,
  useOkulSinifSubeleriQuery,
  useSinifSubeDetayQuery,
  useSinifSubeEkleMutation,
} from '../../../../../gql/GeneratedGraphqlTypes'
import Spinner from '../../../../spinner/Spinner'

const ClassBranchesDetailPage = () => {
  const { id } = useParams()
  const [form] = Form.useForm()
  const { okul } = useContext(AppContext)
  const navigate = useNavigate()

  const [sinifSubesiEkleMutation] = useSinifSubeEkleMutation()

  const {
    data: subeData,
    loading: subeLoading,
    error: subeError,
  } = useSinifSubeDetayQuery({
    variables: {
      id: parseInt(id ? id : '0'),
    },
    skip: !id,
    fetchPolicy: 'network-only',
  })

  const { data, loading, error } = useOkulSinifSubeleriQuery({
    variables: {
      sube_id: okul?.id,
    },
    fetchPolicy: 'network-only',
  })

  const {
    data: kampusData,
    loading: kampusLoading,
    error: kampusError,
  } = useOkulKampusleriQuery({
    variables: {
      sube_id: okul?.id,
    },
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (id && subeData?.sinifSubeDetay && data?.okulSinifSubeleri?.sinif_subeleri) {
      form.setFieldsValue({
        sube_id: subeData.sinifSubeDetay?.sube_id,
        ust_kategori: subeData.sinifSubeDetay.ust_kategori !== null ? Number(subeData.sinifSubeDetay.ust_kategori) : undefined,
        isim: subeData.sinifSubeDetay?.isim,
      })
    }
  }, [subeData, data, form, id])

  if (subeLoading || loading || kampusLoading) {
    return <Spinner color="red" showSpinner={true} />
  }

  if (subeError || error || kampusError) {
    notification.success({
      message: '',
      description: `Bir hata meydana geldi`,
      duration: 6,
    })
  }

  const handleSubmit = async () => {
    const values = await form.validateFields()
    const input = {
      isim: values.isim,
      ust_kategori: values.ust_kategori,
      sube_id: values.sube_id,
      id: parseInt(id ? id : '0'),
    }

    try {
      const response = await sinifSubesiEkleMutation({
        variables: {
          input: {
            isim: input.isim,
            ust_kategori_id: input.ust_kategori,
            sube_id: input.sube_id,
            id: input.id,
          },
        },
      })

      if (response.data?.sinifSubeEkle.success) {
        notification.success({
          message: '',
          description: response.data?.sinifSubeEkle?.message,
          duration: 6,
        })
        navigate(-1)
      } else {
        notification.error({
          message: '',
          description: response.data?.sinifSubeEkle?.message || 'Bir hata oluştu',
        })
      }
    } catch {
      notification.error({
        message: '',
        description: 'Listeyi gönderirken bir hata oluştu.',
        duration: 6,
      })
    }
  }

  return (
    <div className="sinif-subeleri-detail-page">
      {id ? (
        <div>
          <h1>Sınıf Kategorisi Detay</h1>
          <Form onFinish={handleSubmit} form={form} className="okul-yonetim-detail-form" layout="vertical">
            <Row className="user-info-row" gutter={16}>
              <Col span={24} className="user-info-col">
                <Col span={8}>
                  <Form.Item
                    label="Kampüs"
                    name="sube_id"
                    rules={[{ required: true, message: 'Lütfen en az bir kampüs seçin!' }]}
                  >
                    <Select
                      allowClear
                      size="large"
                      style={{ width: '100%' }}
                      placeholder="Kampüs seçiniz"
                      optionFilterProp="label"
                      options={kampusData?.okulKampusleri?.kampusler.map((kampus: any) => ({
                        label: kampus.isim,
                        value: kampus.id,
                      }))} // Tüm kampüsler her zaman gösterilecek
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Üst Sınıf Şubesi" name="ust_kategori">
                    <Select
                      showSearch
                      suffixIcon={null}
                      size="large"
                      allowClear
                      placeholder="Üst Sınıf Şubesi"
                      optionFilterProp="label"
                      options={data?.okulSinifSubeleri?.sinif_subeleri?.map((item) => ({
                        label: item?.isim,
                        value: Number(item?.id),
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="İsim" name="isim">
                    <Input placeholder="İsim giriniz" />
                  </Form.Item>
                </Col>
              </Col>
            </Row>
            <Button className="back-btn" onClick={() => navigate(-1)}>
              Geri
            </Button>
            <Button className="update-btn" htmlType="submit">
              Güncelle
            </Button>
          </Form>
        </div>
      ) : (
        <>
          <div>
            <h1>Yeni Sınıf Kategorisi Ekle</h1>
            <Form onFinish={handleSubmit} form={form} className="okul-yonetim-detail-form" layout="vertical">
              <Row className="user-info-row" gutter={16}>
                <Col span={24} className="user-info-col">
                  <Col span={8}>
                    <Form.Item
                      label="Kampüs"
                      name="sube_id"
                      rules={[{ required: true, message: 'Lütfen en az bir kampüs seçin!' }]}
                    >
                      <Select
                        allowClear
                        size="large"
                        style={{ width: '100%' }}
                        placeholder="Kampüs seçiniz"
                        optionFilterProp="label"
                        options={kampusData?.okulKampusleri?.kampusler.map((kampus: any) => ({
                          label: kampus.isim,
                          value: kampus.id,
                        }))} // Tüm kampüsler her zaman gösterilecek
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="Üst Sınıf Şubesi" name="ust_kategori">
                      <Select
                        showSearch
                        suffixIcon={null}
                        size="large"
                        allowClear
                        placeholder="Üst Sınıf Şubesi"
                        optionFilterProp="label"
                        options={data?.okulSinifSubeleri?.sinif_subeleri?.map((item) => ({
                          label: item?.isim,
                          value: Number(item?.id),
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item label="İsim" name="isim">
                      <Input placeholder="İsim giriniz" />
                    </Form.Item>
                  </Col>
                </Col>
              </Row>

              <Button className="back-btn" onClick={() => navigate(-1)}>
                Geri
              </Button>
              <Button className="update-btn" htmlType="submit">
                Kaydet
              </Button>
            </Form>
          </div>
        </>
      )}
    </div>
  )
}

export default ClassBranchesDetailPage
